import React from 'react';
import { styled } from '../../../stitches.config';

const ErrorPlaceholder = styled("div", {
    backgroundColor: "$grayscale100Fixed",
    height: "440px",
    minHeight: "440px",
    width: "100%",
    "@bp4": {
        height: "500px",
        width: "100%",
    },
});


export default ErrorPlaceholder;